// Remembers which funnel a user entered through (e.g. /weekly) so logout and
// the post-payment redirect send them back into that same funnel.
// Survives logout: clearSession() wipes everything except this marker.

const ENTRY_KEY = 'dastaan__entry';

export const markWeeklyEntry = () => {
  try { localStorage.setItem(ENTRY_KEY, 'weekly'); } catch (e) {}
};

export const isWeeklyEntry = () => {
  try { return localStorage.getItem(ENTRY_KEY) === 'weekly'; } catch (e) { return false; }
};

// localStorage.clear() that keeps the entry marker.
export const clearSession = () => {
  const entry = localStorage.getItem(ENTRY_KEY);
  localStorage.clear();
  if (entry) localStorage.setItem(ENTRY_KEY, entry);
};

export const logoutRedirectPath = () => (isWeeklyEntry() ? '/weekly' : '/');

export const paymentSuccessPath = () => (isWeeklyEntry() ? '/weekly/success' : '/payment-success');
